(function () {
  function getRateEl() {
    return document.getElementById('variant-monthly-rate');
  }

  function getVariantId() {
    return document.querySelector('form[action*="/cart/add"] [name="id"]')?.value || null;
  }

  function getRatesMap(rateEl) {
    try {
      return JSON.parse(rateEl.getAttribute('data-variant-rates') || '{}');
    } catch {
      return {};
    }
  }

  function render(rateEl, rate) {
    if (rate && String(rate).trim() !== '') {
      rateEl.style.display = '';
      const valueEl = rateEl.querySelector('.monthly-rate-value');
      if (valueEl) valueEl.textContent = rate;
      else rateEl.innerHTML = 'oder <strong class="monthly-rate-value">' + rate + '</strong> / Monat';
    } else {
      rateEl.style.display = 'none';
    }
  }

  function update() {
    const rateEl = getRateEl();
    if (!rateEl) return;

    const variantId = getVariantId();
    if (!variantId) return;

    const map = getRatesMap(rateEl);
    render(rateEl, map[String(variantId)]);
  }

  document.addEventListener('DOMContentLoaded', () => {
    update();

    // 1) normale Variantenauswahl feuert meistens ein change irgendwo im Product-Form-Bereich
    document.addEventListener('change', () => update());

    // 2) Falls Horizon die hidden id per JS setzt ohne change:
    const idInput = document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (idInput) {
      let last = idInput.value;
      setInterval(() => {
        if (idInput.value !== last) {
          last = idInput.value;
          update();
        }
      }, 150);
    }
  });
})();
